<div
  class="counter text-10 pt-1 pb-1"
  [class.counter--inline]="display === 'inline'"
  [ngSwitch]="mode"
  *ngIf="max">
  <span *ngSwitchCase="'remaining'" class="counter__label"
    >{{ remainingCount }} {{ remainingCount === 1 ? 'character' : 'characters' }} remaining</span
  >
  <span *ngSwitchDefault class="counter__label">{{ count }}/{{ max }}</span>
</div>
